'use client'

import type { Components } from 'react-markdown'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { stripTypographicLongDashes } from '@/lib/stripTypographicLongDashes'

type SupportMessageMarkdownProps = {
  content: string
  variant: 'user' | 'bot'
}

export function SupportMessageMarkdown({ content, variant }: SupportMessageMarkdownProps) {
  const display = stripTypographicLongDashes(content ?? '')
  if (!display.trim()) return null

  const isUser = variant === 'user'

  const containerClass = isUser
    ? 'prose prose-sm max-w-none text-white prose-invert first:prose-p:mt-0 last:prose-p:mb-0 prose-p:my-1.5 prose-headings:mb-2 prose-headings:mt-3 first:prose-headings:mt-0 prose-ul:my-1.5 prose-ol:my-1.5 prose-li:my-0.5 prose-code:rounded-md prose-code:bg-white/20 prose-code:px-1 prose-code:py-0.5 prose-code:before:content-none prose-code:after:content-none [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5'
    : 'prose prose-sm max-w-none text-[#183b56] first:prose-p:mt-0 last:prose-p:mb-0 prose-p:my-1.5 prose-headings:text-[#183b56] prose-headings:mb-2 prose-headings:mt-3 first:prose-headings:mt-0 prose-strong:text-[#183b56] prose-li:marker:text-[#183b56] prose-ul:my-1.5 prose-ol:my-1.5 prose-li:my-0.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5'

  const linkClass = isUser
    ? 'text-white/95 underline decoration-white/40 underline-offset-2 hover:decoration-white/80'
    : 'text-[#6155f5] font-semibold underline decoration-[#6155f5]/40 underline-offset-2 hover:decoration-[#6155f5]'

  const components: Components = {
    a: ({ href, children, ...props }) => (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
        {...props}
      >
        {children}
      </a>
    ),
  }

  return (
    <div className={`font-montserrat ${containerClass} break-words`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {display}
      </ReactMarkdown>
    </div>
  )
}
